<template>
  <div class="content">
    <img src="../assets/Aboutus_banner.png" style="width:100%;height:100%;margin-bottom:-8px;">
    <div style="margin:100px 119px;height:auto;overflow:hidden;">
      <p style="font-size:16px;color:#000;line-height:30px;margin-bottom: 55px;">公司搜索到
        <span style="color:red;">{{ searchList.length }}条</span>
        相关记录
      </p>
      <p style="font-size:18px;color:#000;font-weight:bold;padding-bottom: 16px;border-bottom: 1px solid #E9E9E9;margin-bottom: 26px;">公司产品搜索结果
        <span>({{ searchList.length }})</span>
      </p>
      <div style="width:100%;margin-bottom: 45px;">
        <a class="a1 product_name" v-for="(item, index) in searchList" :key="index" @click="goProduct(item)">{{ item.name }}</a>
      </div>
    </div>
  </div>
</template>
<script>
    import bus from '@/bus/index'
    export default {
        name: 'Searchproduct',
        data () {
            return {
              searchList: [],
            }
        },
        mounted() {},
        created() {
          this.searchList =JSON.parse(localStorage.getItem('searchList'));
          console.log(this.searchList, 'this.searchList');
          bus.$on('searchKey',()=>{
            setTimeout(()=>{
              this.searchList = JSON.parse(localStorage.getItem('searchList'));
            },20)
          })
        },
        methods: {
          // 调转product详情
          goProduct(item) {
            this.$router.push({
              path: './Product',
              query: {
                id: item.id
              }
            });
          },
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.product_name {
  line-height: 46px;
  color: #555555;
  padding: 0 45px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 40%;
  float: left;
  font-size: 16px;
}
a:after{
  content: "";
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: #535353;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 20px;
}
</style>